import React, {Component} from 'react';
import {Modal} from 'semantic-ui-react';
import {connect} from 'react-redux';

import EmailVerificationForm from "../auth/EmailVerification/EmailVerificationForm"
import {closeModal} from "./modalActions";

const actions = {closeModal};

class EmailVerificationModal extends Component {
    render() {
        return (
            <Modal
                size='mini'
                open={true}
                onClose={this.props.closeModal}
            >
                <Modal.Header>
                    If you have not received the verification email, you can resend the email
                </Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        <EmailVerificationForm />
                    </Modal.Description>
                </Modal.Content>
            </Modal>
        );
    }
}

export default connect(null, actions)(EmailVerificationModal);